import React from 'react';
import Loadable from 'components/Loadable';
import {PrivateLayout} from 'components/Layouts';

import renderRoutes from 'pages/routes';

export default {
  exact: false,
  auth: true,
  path: '/events',
  component: ({routes}) => {
    return <PrivateLayout>{renderRoutes(routes)}</PrivateLayout>;
  },
  routes: [
    {
      exact: true,
      auth: true,
      path: '/events',
      component: Loadable({
        loader: () => import('./lists')
      })
    },
    {
      exact: true,
      auth: true,
      path: '/events/create',
      component: Loadable({
        loader: () => import('./create')
      })
    },
    {
      exact: true,
      auth: true,
      path: '/events/:id',
      component: Loadable({
        loader: () => import('./show')
      })
    },
    {
      exact: true,
      auth: true,
      path: '/events/:id/edit',
      component: Loadable({
        loader: () => import('./edit')
      })
    }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/back/events/index.js